import { ReactComponent as PraxisProLogo } from "../assets/icons/logo-white-bg.svg";
import { ReactComponent as DownloadIcon } from "../assets/icons/download.svg";

const CHROME_DOWNLOAD_URL = "https://www.google.com/chrome/";
const EDGE_DOWNLOAD_URL = "https://www.microsoft.com/edge";

export default function BrowserRequiredScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#7c2928] via-[#bd4b28] to-[#db622b] flex flex-col items-center justify-center text-center">
      <PraxisProLogo className="w-64 mb-8" />
      <h1 className="text-[20px] font-semibold text-white mb-4 leading-[1.5]">
        PraxisPro requires Chrome or Edge
      </h1>
      <p className="text-[16px] font-normal text-white mb-8 leading-[1.5]">
        For the best experience
        <br />
        please open PraxisPro in Google Chrome or Microsoft Edge.
      </p>
      <div className="flex items-center gap-4">
        <a
          href={CHROME_DOWNLOAD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 bg-white text-[#3f3f46] text-[16px] font-semibold px-9 py-3 rounded-lg h-12 leading-[1.5]"
        >
          <DownloadIcon className="w-6 h-6 [&_path]:fill-[#3f3f46]" />
          Download Chrome
        </a>
        <a
          href={EDGE_DOWNLOAD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 bg-white text-[#3f3f46] text-[16px] font-semibold px-9 py-3 rounded-lg h-12 leading-[1.5]"
        >
          <DownloadIcon className="w-6 h-6 [&_path]:fill-[#3f3f46]" />
          Download Edge
        </a>
      </div>
    </div>
  );
}
